import React, { useContext, useEffect } from "react";
import { GoAButton, GoACallout, GoASpacer } from "@abgov/react-components";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../state/store';
import {
  getLoginInfoFromJwt,
  isUserLoggedIn,
  logout,
  clearLogoutFlag
} from '../state/slices/authSlice';



const LogoutComponent = () => {

  const dispatch = useDispatch<AppDispatch>();

  localStorage.clear()
  sessionStorage.removeItem("reduxState");
  sessionStorage.clear()

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <main>
      {/* <GoASpacer vSpacing={"2xl"} /> */}
      <h1>You have been logged out.</h1>
      {/* <GoASpacer vSpacing={"l"} /> */}

    </main>
  );
};

export default LogoutComponent;
